var byServiceFilter = function () {
    var serviceSelect = $('[data-id="byservice-filter"]');
    var serviceButton = $('[data-id="byservice-filter-button"]');
    var serviceSections = $('.m-byServiceSection');

    serviceButton.on("click", function (evt) {
        var selectedSection = serviceSelect.val();

        if (selectedSection == "all") {
            serviceSections.show();
        }
        else {
            serviceSections.hide();
            $('#' + selectedSection).show();
        };

        islington.giveScreenreaderAlert(`${serviceSelect.find("option:selected").text()} filter has been applied`, 'sr-filter-announement');

    });
    $('div#Birthsdeathsmarriageandcitizenship h3 span').html('Births, deaths, marriage and citizenship');
    $('div#Physicalactivityparksandtrees h3 span').html('Physical activity, parks and trees');
    $('div#Librariesheritageandarts h3 span').html('Libraries, heritage and arts');
    $('select#service-category option[value=Birthsdeathsmarriageandcitizenship]').html('Births, deaths, marriage and citizenship');
    $('select#service-category option[value=Physicalactivityparksandtrees]').html('Physical activity, parks and trees');
    $('select#service-category option[value=Librariesheritageandarts]').html('Libraries, heritage and arts');
};